module.exports = __webpack_public_path__ + "img/zbjh.2ef96048.jpg";